import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_3 = {
  class: "modal",
  style: {"width":"500px"}
}
const _hoisted_4 = { class: "modal__header modal__header--success" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "clipboard__header--title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-briefcase" }),
  /*#__PURE__*/_createTextVNode(" Active Auto Data")
], -1)
const _hoisted_6 = { class: "modal__content pa-1" }
const _hoisted_7 = { class: "pa--y-1 pa--left-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Active Auto Data"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text--style-italic",
    style: {"font-size":"80%"}
  })
], -1)
const _hoisted_9 = {
  class: "stepper--bar__content--label__info--message pa-1",
  style: {"font-size":"14px"}
}
const _hoisted_10 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_11 = {
  class: "stepper--bar__content--label__info--message pa-1",
  style: {"font-size":"14px"}
}
const _hoisted_12 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_13 = {
  class: "stepper--bar__content--label__info--message pa-1",
  style: {"font-size":"14px"}
}
const _hoisted_14 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_15 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_16 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_17 = {
  class: "stepper--bar__content--label__info--message pa-1",
  style: {"font-size":"14px","border-bottom":"1px solid white"}
}
const _hoisted_18 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px","border-bottom":"1px solid white"}
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoDataDelivery = _resolveComponent("AutoDataDelivery")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("a", {
          class: "fa fa-times clipboard__header--clear",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode(" Project Name "),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.projectName), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createTextVNode(" Frequency "),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.activeAutoData.frequency), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createTextVNode(" No of Leads "),
            _createElementVNode("span", _hoisted_14, _toDisplayString((_ctx.activeAutoData.type == "PROCESS_ALL_AVAILABLE_LEADS")?"All Available Leads":_ctx.activeAutoData.customLeadNumbers), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createTextVNode(" Filters "),
            _createElementVNode("span", _hoisted_16, _toDisplayString(JSON.parse(_ctx.activeAutoData.filters)), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createTextVNode(" Recipients "),
            _createElementVNode("span", _hoisted_18, [
              _createElementVNode("div", {
                innerHTML: _ctx.getFormattedEmail(_ctx.activeAutoData.emailAddressesDelimited)
              }, null, 8, _hoisted_19)
            ])
          ]),
          (_ctx.toggleAutoDataDeliveryModel)
            ? (_openBlock(), _createBlock(_component_AutoDataDelivery, {
                key: 0,
                isEdit: true,
                selectedLeadsLength: 0,
                onCloseAutoDataDeliveryModel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeAutoDataDeliveryModel()))
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_20, [
          (_ctx.isAdmin || _ctx.isSuperAdmin)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn--secontary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.autoLeadConfirm()))
              }, " Edit "))
            : _createCommentVNode("", true),
          (_ctx.isAdmin || _ctx.isSuperAdmin)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn--secontary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteAutoLead()))
              }, " Delete "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn--primary",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, " Close ")
        ])
      ])
    ])
  ]))
}